// @flow
import {
	getComparisonData as getComparisonDataRequest,
	getAverageGrades as getAverageGradesRequest,
	getTopGrades as getTopGradesRequest,
	getCities as getCitiesRequest,
	getStudies as getStudiesRequest,
} from 'api';
import { GET_AVG_GRADES, GET_TOP_GRADES, GET_CITIES, GET_STUDIES, GET_COMPARISON_DATA } from 'client/constants/actions';
import type { AverageGradesOptions, TopGradesOptions } from 'api';
import type { Store } from 'client/reducers';

export type Action = { type: string, payload?: any };
export type ThunkAction = (dispatch: Dispatch, getState: () => Store) => Promise<any>;
export type Dispatch = (action: Action | ThunkAction | Promise<Action>) => Promise<void>;

export function getComparisonData(options: AverageGradesOptions): ThunkAction {
	return async (dispatch: Dispatch) => {
		dispatch({ type: GET_COMPARISON_DATA.GET });

		const { data } = await getComparisonDataRequest(options);

		dispatch({ type: GET_COMPARISON_DATA.SUCCESS, payload: data });

		return data;
	};
}

export function getAverageGrades(options: AverageGradesOptions): ThunkAction {
	return async (dispatch: Dispatch) => {
		dispatch({ type: GET_AVG_GRADES.GET });

		const { data } = await getAverageGradesRequest(options);

		dispatch({ type: GET_AVG_GRADES.SUCCESS, payload: data });

		return data;
	};
}

export function getTopGrades(options: TopGradesOptions): ThunkAction {
	return async (dispatch: Dispatch) => {
		dispatch({ type: GET_TOP_GRADES.GET });

		const { data } = await getTopGradesRequest(options);

		dispatch({ type: GET_TOP_GRADES.SUCCESS, payload: data });

		return data;
	};
}

export function getCities(): ThunkAction {
	return async (dispatch: Dispatch) => {
		dispatch({ type: GET_CITIES.GET });

		const { data } = await getCitiesRequest();

		dispatch({ type: GET_CITIES.SUCCESS, payload: data });

		return data;
	};
}

export function getStudies(): ThunkAction {
	return async (dispatch: Dispatch) => {
		dispatch({ type: GET_STUDIES.GET });

		const { data } = await getStudiesRequest();

		dispatch({ type: GET_STUDIES.SUCCESS, payload: data.ordered });

		return data.ordered;
	};
}
